import { createFileRoute } from "@tanstack/react-router";
import MakeModelPage from "@/pages/MakeModelPage";
import { routeHead } from "@/lib/seo/route-head";
import { listingsV2QueryOptions } from "@/lib/queries/publicData";
import { isEligibleCityListing } from "@/utils/cityArea";

export const Route = createFileRoute("/cars/$make/")({
  head: ({ params, loaderData }) => {
    const base = routeHead("/cars/$make/", params as Record<string, string>);
    // A brand with no active listings (or an unknown slug) stays out of the index.
    if ((loaderData as { count?: number | null } | undefined)?.count !== 0) return base;
    return {
      meta: [...base.meta.filter((m) => m.property !== "og:url"), { name: "robots", content: "noindex, follow" }],
      links: [],
    };
  },
  loader: async ({ context, params }) => {
    // Must match exactly the query used by MakeModelPage (useListingsV2),
    // otherwise SSR primes a different cache key and the page renders empty.
    const make = params.make
      ? params.make.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
      : undefined;
    const rows = await context.queryClient
      .ensureQueryData(listingsV2QueryOptions({ country_code: "RO", make, limit: 200 }))
      .catch(() => undefined);
    // Same rule as the page and the directory: active passenger cars only.
    return { count: Array.isArray(rows) ? rows.filter(isEligibleCityListing).length : (null as number | null) };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <MakeModelPage />
  );
}
